<template>
  <div>
    <div v-if="wWidth < 976" style="background:#fff;">
      <el-tabs v-if="wWidth < 976" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane  v-if="!$store.state.isPreview" :label="$t('message.learning_progress')" name="progress"></el-tab-pane>
        <el-tab-pane :label="$t('message.learning_content')" name="content"></el-tab-pane>
        <el-tab-pane :label="$t('message.course_catalog')" name="catalog"></el-tab-pane>
      </el-tabs>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "progress"
    };
  },
  watch: {
    activeName(val) {
      if (val == "progress") {
        this.$router.push({
          path: "/learning",
          query: {
            ...this.myQuery,
            activeName: val
          }
        });
      } else {
        this.$router.push({
          path: "/learning/course",
          query: {
            ...this.myQuery,
            chapterIndex: this.$route.query.chapterIndex || 0,
            activeName: val
          }
        });
      }
    },
    $route(to, from) {
      this.activeName = this.$route.query.activeName || "content";
    }
  },
  computed: {
    wWidth() {
      return this.$store.state.wWidth;
    },
    myQuery() {
      return this.$route.query;
    }
  },
  methods: {
    handleClick(event) {
      return;
    }
  },
  created() {
    this.activeName = this.$route.query.activeName || "progress";
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs {
  border-bottom: 1px solid #dfdfdf;
  padding-bottom: 10px;

  .el-tabs__header {
    margin: 0px;

    .el-tabs__item {
      font-size: 16px;
      color: #3e4143;
    }

    .el-tabs__item:hover,
    .el-tabs__item.is-active {
      color: #16b695;
    }

    .el-tabs__active-bar {
      background-color: #16b695;
      height: 4px;
      border-radius: 3px;
      padding: 0 5px;
      left: -4px;
    }

    .el-tabs__nav-wrap::after {
      height: 0;
    }

    .el-tabs__nav {
      margin-left: 10px;
    }
  }
}
</style>